import type {
  IDishDetailsFormValues,
  IDishDetailsModalViewModel,
} from "@/types";

export const buildInitialDishDetailsFormValues = (
  viewModel: IDishDetailsModalViewModel | null
): IDishDetailsFormValues => {
  if (!viewModel) {
    return { portionId: 0, dishQuantity: 1, supplements: [] };
  }

  const sortedPortions = [...(viewModel.portions ?? [])].sort(
    (a, b) => Number(a.price) - Number(b.price)
  );

  const portionId = sortedPortions[0]?.id ?? 0;

  const supplements = (viewModel.supplements ?? [])
    .filter(
      (group) => (group.numberOfOption ?? 0) === 1 && group.isRequireOnOrder
    )
    .map((group) => {
      const firstOptionId = group.options?.[0]?.id ?? null;
      if (firstOptionId == null) return null;

      return {
        supplementId: group.id,
        options: [{ optionId: firstOptionId, quantity: 1 }],
      };
    })
    .filter(Boolean) as IDishDetailsFormValues["supplements"];

  return {
    portionId,
    dishQuantity: 1,
    supplements,
  };
};

export const safeNumber = (value: number | null | undefined) =>
  typeof value === "number" ? value : 0;

export const normalizeText = (value: string | null | undefined) =>
  (value ?? "").trim();
